import React from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  formatDateReadable,
  formatTimestampDateReadable,
  formatTimestampReadable,
} from "../../utilities/helpers.js";
import { getInitials } from "../../utilities/helpers.js";
import { get_t_str } from "../../../../../helpers/helpers.js";
import AvatarSmall from "../../shared/helpers/AvatarSmall.js";
import TimeOffRequestDrawer from "./TimeOffRequestDrawer.js";

export default function TimeOffRequestsTableRow(props) {
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer transition-colors"
        onClick={() => setDrawerOpen(true)}
      >
        <td className="whitespace-nowrap py-3.5 pl-6 pr-3 text-sm">
          <div className="flex items-center">
            <AvatarSmall
              initials={getInitials(props.firstName, props.lastName)}
            />
            <div className="ml-3">
              <div className="font-semibold text-slate-900">
                {props.firstName} {props.lastName}
              </div>
            </div>
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
          <Tooltip title={formatTimestampReadable(props.dateSubmitted, props.storeTimezone)}>
            <div className="text-slate-500">
              {formatTimestampDateReadable(props.dateSubmitted, props.storeTimezone)}
            </div>
          </Tooltip>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
          <div>
            <span>{formatDateReadable(props.startDate)}</span>
            {props.endDate && (
              <span> &mdash; {formatDateReadable(props.endDate)}</span>
            )}
          </div>
          {(props.startTime && props.endTime) &&
            <div className="text-slate-400 text-xs mt-0.5">
              {get_t_str(props.startTime)} &mdash; {get_t_str(props.endTime)}
            </div>
          }
        </td>
        <td className="py-3.5 px-3 text-sm" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
          <div className="font-semibold text-slate-900">{props.title}</div>
          {props.note && (
            <div className="text-xs text-slate-400 mt-0.5">{props.note}</div>
          )}
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
          {props.time_off_type ? (
            props.time_off_type === 'UNPAID' ? 'Unpaid' :
            props.time_off_type === 'PTO' ? 'PTO' :
            props.time_off_type === 'SICK' ? 'Sick' :
            'Not specified'
          ) : (
            <span className="text-slate-400">&mdash;</span>
          )}
        </td>
        <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
        </td>
      </tr>

      <TimeOffRequestDrawer
        isDrawerOpen={isDrawerOpen}
        setDrawerOpen={setDrawerOpen}
        requestInfo={{
          uuid: props.uuid,
          firstName: props.firstName,
          lastName: props.lastName,
          title: props.title,
          time_off_type: props.time_off_type,
          startDate: props.startDate,
          endDate: props.endDate,
          startTime: props.startTime,
          endTime: props.endTime,
          note: props.note,
          dateSubmitted: props.dateSubmitted,
        }}
        respond_to_time_off_request={props.respond_to_time_off_request}
        storeTimezone={props.storeTimezone}
      />
    </>
  );
}
